<template>

  <div style="margin-left: 70px">
    <el-button v-if="this.parentData" type="success" @click="deleteChartData">{{"数据修复"}}</el-button>
  </div>

  <div class="pageContainer">

    <div class="asideContainer" style="border-right: 8px solid whitesmoke;">

      <div class="size">
        <div class="title">{{'组立直行率-物件'}}
          <el-select v-model="wuJianId" @change="renderAllEcharts" clearable placeholder="物件名称" size="small" class="wujian_select_size">
            <el-option
                v-for="item in wuJianNames"
                :key="item.value"
                :label="item.label"
                :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="chart_size" v-loading="wuJianChartLoading" element-loading-text="数据加载中" style="width: 470px;height: 260px" id="wuJianZhiXing"/>
      </div>

    </div>

    <div class="asideContainer">


    </div>

    <KfDialog v-model="dialogVisible" :item="dialogItem">

      <template #footer>
        <div style="display: flex;flex-direction: column;align-items: center;justify-content: space-around;">
          <div style="width:100%; display: flex;flex-direction: row;align-items: center;justify-content: space-around;">
            <span style="font-size: 24px;">{{this.chartData.name}}</span>
            <el-input-number v-model="this.chartData.value"/>
          </div>
          <el-button style="margin-top: 20px" type="primary" @click="editChartData">{{"保存"}}</el-button>
        </div>
      </template>
    </KfDialog>

  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "ZuLiZhiXingPage",
  props: ['parentData'],
  data(){
    return{
      dialogVisible:false,
      dialogItem:{
        title:'',
        width:'30%'
      },
      chartData:{},
      wuJianId:'',
      wuJianNames:[],
      /*物件别玻璃不良推移*/
      wujianQuery:{},
      optionWuJian: {
        type:"wujian_chart",
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999'
            }
          }
        },
        legend: {
          //data: ['Evaporation', 'Precipitation', 'Temperature']
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisPointer: {
              type: 'shadow'
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: '单元总数',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: '{value}'
            }
          },
          {
            type: 'value',
            name: '不良率',
            min: 0,
            max: 100,
            interval: 20,
            axisLabel: {
              formatter: function (value){
                return value.toFixed(1) + '%'
              }
            }
          }
        ],
        series: [
          {
            name: '完成品数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '不良数量',
            type: 'bar',
            tooltip: {
              valueFormatter: function (value) {
                return value;
              }
            },
            data: [
            ]
          },
          {
            name: '目标',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: [
            ]
          },
          {
            name: '直行率',
            type: 'line',
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return value + '%';
              }
            },
            data: []
          }
        ],
        dataZoom:[
          {
            start: 0,
            end: 100,//默认为100
            type: 'slider',
            show: true,
            // xAxisIndex: [0],
            handleSize: 0,//滑动条的 左右2个滑动条的大小
            startValue: null, // 初始显示值
            endValue: null, // 结束显示值
            height: 15,//组件高度
            left: '5%', //左边的距离
            right: '4%',//右边的距离
            borderRadius: 5,
            showDataShadow: false,//是否显示数据阴影 默认auto
            showDetail: true,//即拖拽时候是否显示详细数值信息 默认true
            realtime: false, //是否实时更新
            filterMode: 'filter',
          },
          //下面这个属性是里面拖到
          {
            type: 'inside',
            show: true,
            // xAxisIndex: [0],
            start: 1,//默认为1
            end: 100,//默认为100
          },
        ]
      },
      wuJianChartLoading:false,
    }
  },
  methods:{
    renderEcharts(id,option){
      if (document.getElementById(id)) {
        echarts.init(document.getElementById(id)).dispose();
        let chart = echarts.init(document.getElementById(id));
        chart.setOption(option)
        /*let time
        let _this = this
        //chart绑定滚动事件
        chart.on('dataZoom',function (params) {
          //滚动条事件添加防抖
          clearTimeout(time)
          time = setTimeout(()=>{
            _this.getWuJianChartData(params)
          },1000)
        })*/

        let _this = this
        if (this.parentData) {
          chart.on('click', function (params) {
            _this.dialogVisible = true
            _this.dialogItem.title = params.seriesName
            _this.chartData.seriesName = params.seriesName
            _this.chartData.value = params.value
            _this.chartData.name = params.name
            _this.chartData.dataIndex = params.dataIndex
            _this.chartData.seriesIndex = params.seriesIndex
            _this.chartData.chartType = option.type
          })
        }
      }
    },

    renderAllEcharts(){
      this.getWuJianChart()
    },

    async deleteChartData(){
      let {data: res} = await this.$axios.post('bus/homePage/deleteChartData',"bus_zulizhixing_page");
      if (res.code !== 0) {
        this.$message.error('刷新失败！请重试')
      }else {
        this.$message.success('刷新成功！')
        this.renderAllEcharts()
      }
    },

    async editChartData(){
      switch (this.chartData.chartType){
        case "wujian_chart":
          this.wujianQuery.wujian_id = this.wuJianId
          this.chartData.query = this.wujianQuery
          break
      }
      this.chartData.model = "bus_zulizhixing_page"
      this.chartData.dataKey = this.$common.getChartDataKey(this.chartData)
      let {data: res} = await this.$axios.post('bus/homePage/editChartData',this.chartData);
      if (res.code !== 0) {
        this.$message.error('修改失败！请重试')
      }else {
        this.$message.success('修改成功！')
        this.dialogVisible = false
      }
      switch (this.chartData.chartType){
        case "wujian_chart":
          await this.getWuJianChart()
          break
      }

    },

    async getWuJianInFo() {
      let {data: res} = await this.$axios.post('bus/datasource/getWuJianInFo');
      if (res.code !== 0) {
        this.$message.error('获取【物件信息】失败')
        return;
      }
      this.wuJianNames = res.data;
    },

    async getWuJianChart() {
      this.wuJianChartLoading = true
      this.wujianQuery.wujian_id = this.wuJianId
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/zhiXingChart',this.wujianQuery);
      console.log(res)
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.optionWuJian.series[0].data = null
        this.optionWuJian.series[1].data = null
        this.wuJianChartLoading = false
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.series[0].data
          this.optionWuJian.series[1].data = res.data.series[1].data
          this.optionWuJian.series[3].data = res.data.series[2].data
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.series[0].data,...res.data.series[1].data)/100)*100
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max / 5 * 100) / 100
          this.optionWuJian.yAxis[1].max = Math.max(...res.data.series[2].data)
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max / 5 * 100) / 100
          this.optionWuJian.dataZoom[0].start = Math.max((this.optionWuJian.xAxis[0].data.length - 4),0) * 100 / this.optionWuJian.xAxis[0].data.length
          this.optionWuJian.dataZoom[0].end = 100
        }
      }
      this.renderEcharts('wuJianZhiXing',this.optionWuJian)

      this.wuJianChartLoading = false
    },

   /* async getWuJianChartData(params) {
      let range
      if (params.batch){
        range = params.batch[0]
      }else {
        range = params
      }
      this.wuJianChartLoading = true
      let query = {
        wuJianId:this.wuJianId,
        start:Math.floor(this.optionWuJian.xAxis[0].data.length * range.start/100),
        end:Math.ceil(this.optionWuJian.xAxis[0].data.length * range.end/100),
      }
      let {data: res} = await this.$axios.post('bus/zuLiZhiJian/zhiXingChart',JSON.stringify(query));
      if (res.code !== 0) {
        this.$message.error(res.message)
        this.wuJianChartLoading = false
      }else {
        if (res.data.XMonth) {
          this.optionWuJian.xAxis[0].data = res.data.XMonth
          this.optionWuJian.series[0].data = res.data.wcpNum
          this.optionWuJian.series[1].data = res.data.badNum
          this.optionWuJian.series[3].data = res.data.badPercent
          this.optionWuJian.yAxis[0].max = Math.ceil(Math.max(...res.data.wcpNum,...res.data.badNum)/100)*100
          this.optionWuJian.yAxis[0].interval = Math.round(this.optionWuJian.yAxis[0].max / 5 * 100) / 100
          this.optionWuJian.yAxis[1].max = Math.max(...res.data.badPercent) + 5
          this.optionWuJian.yAxis[1].interval = Math.round(this.optionWuJian.yAxis[1].max / 5 * 100) / 100
          this.optionWuJian.dataZoom[0].start = range.start
          this.optionWuJian.dataZoom[0].end = range.end
        }
        this.renderEcharts('wuJianZhiXing',this.optionWuJian)
      }
      this.wuJianChartLoading = false
    },*/
  },

  created() {
    this.getWuJianInFo()
  },

  mounted() {
    this.renderAllEcharts()
  }
}
</script>

<style scoped>
.pageContainer{
  display: flex;
  flex-direction: row;
  overflow: hidden;
  width: 100%;
}

.asideContainer{
  width: 50%;
  height: 450px;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
}

.space-between{
  display: flex;
  flex-direction: row;
  align-items: center;;
}
.chart_size{
  width:770px;
  height: 440px
}
</style>